import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuButanyerera'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const kirundoData = {
  title: "REPARTITION DE LA POPULATION DES MENAGES ORDINAIRES PAR COLLINE, ZONE ET COMMUNE",
  province: {
    id: "1",
    name: "BUHUMUZA",
    commune: {
      id: "101",
      name: "KIRUNDO",
      total: 476758,
      zones: [
        {
          id: "10101",
          name: "LAC RWIHINDA",
          total: 0,
          collines: [
            { id: "10101101", name: "LAC RWIHINDA", population: 0 }
          ]
        },
        {
          id: "10102",
          name: "BUGABIRA",
          total: 9690,
          collines: [
            { id: "10102101", name: "RUHEHE", population: 4633 },
            { id: "10102102", name: "RUSUGI", population: 1941 },
            { id: "10102103", name: "NTAHO", population: 1069 },
            { id: "10102104", name: "GACAMIRINDI", population: 2047 }
          ]
        },
        {
          id: "10103",
          name: "BUKUBA",
          total: 19200,
          collines: [
            { id: "10103101", name: "NYAGATOVU", population: 4996 },
            { id: "10103102", name: "RWISURI", population: 3768 },
            { id: "10103103", name: "GAHE", population: 2236 },
            { id: "10103104", name: "MUYEBE", population: 1478 },
            { id: "10103105", name: "MURAMBA", population: 2219 },
            { id: "10103106", name: "BWINYANA", population: 2337 },
            { id: "10103107", name: "CANZIKIRO", population: 1542 },
            { id: "10103108", name: "NYABIHANGA", population: 624 }
          ]
        },
        {
          id: "10104",
          name: "CENDAJURU",
          total: 24090,
          collines: [
            { id: "10104101", name: "KIZIBA", population: 3978 },
            { id: "10104102", name: "CANIKA", population: 5020 },
            { id: "10104103", name: "KIGOBE", population: 3972 },
            { id: "10104104", name: "CENDAJURU", population: 3457 },
            { id: "10104105", name: "NGERE", population: 2404 },
            { id: "10104106", name: "KABIRIZI", population: 1635 },
            { id: "10104107", name: "RWAMIKORE", population: 1660 },
            { id: "10104108", name: "NYAMISAGARA", population: 1964 }
          ]
        },
        {
          id: "10105",
          name: "CEWE",
          total: 16773,
          collines: [
            { id: "10105101", name: "CERU", population: 5033 },
            { id: "10105102", name: "RUKURAMIGABO", population: 4843 },
            { id: "10105103", name: "RUNYONZA", population: 4038 },
            { id: "10105104", name: "CEWE", population: 2859 }
          ]
        },
        {
          id: "10106",
          name: "GASHINGWA",
          total: 21401,
          collines: [
            { id: "10106101", name: "KIRIMA", population: 2818 },
            { id: "10106102", name: "KIRARO", population: 3222 },
            { id: "10106103", name: "RUGERI", population: 1856 },
            { id: "10106104", name: "GASHINGWA", population: 1804 },
            { id: "10106105", name: "KAVUMU", population: 2119 },
            { id: "10106106", name: "NYAMYUMBA", population: 1968 },
            { id: "10106107", name: "NYAKIBANDA", population: 1972 },
            { id: "10106108", name: "BURARANA", population: 2486 },
            { id: "10106109", name: "MARTYAZO", population: 1829 },
            { id: "10106110", name: "NYAMIVUMA", population: 1327 }
          ]
        },
        {
          id: "10107",
          name: "GIHOSHA",
          total: 26336,
          collines: [
            { id: "10107101", name: "KINYANGURUBE", population: 4095 },
            { id: "10107102", name: "RUGERO", population: 6711 },
            { id: "10107103", name: "GAKANA", population: 3757 },
            { id: "10107104", name: "GIHOSHA", population: 2602 },
            { id: "10107105", name: "SHINGE", population: 3823 },
            { id: "10107106", name: "MUTARA", population: 2458 },
            { id: "10107107", name: "MWENYA", population: 2890 }
          ]
        },
        {
          id: "10108",
          name: "GIKUYO",
          total: 35226,
          collines: [
            { id: "10108101", name: "KANYINYA", population: 8232 },
            { id: "10108102", name: "RAMBO", population: 7655 },
            { id: "10108103", name: "BUGERA", population: 4454 },
            { id: "10108104", name: "GIKUYO", population: 3789 },
            { id: "10108105", name: "MATAKA", population: 3043 },
            { id: "10108106", name: "CUMVA", population: 3290 },
            { id: "10108107", name: "KARAMAGI", population: 2044 },
            { id: "10108108", name: "BUSENYI", population: 2719 }
          ]
        },
        {
          id: "10109",
          name: "KAVOMO",
          total: 26518,
          collines: [
            { id: "10109101", name: "MURAMBA", population: 5082 },
            { id: "10109102", name: "YARANDA", population: 8202 },
            { id: "10109103", name: "KIYANZA", population: 6294 },
            { id: "10109104", name: "KAVOMO", population: 4969 },
            { id: "10109105", name: "KIREKA", population: 1971 }
          ]
        },
        {
          id: "10110",
          name: "KIGINA",
          total: 11100,
          collines: [
            { id: "10110101", name: "KIGINA", population: 2117 },
            { id: "10110102", name: "KARISHA", population: 2187 },
            { id: "10110103", name: "GATURANDA", population: 2336 },
            { id: "10110104", name: "GITORONGERO", population: 2098 },
            { id: "10110105", name: "NYABIKENKE", population: 2362 }
          ]
        },
        {
          id: "10111",
          name: "KIGOMA",
          total: 26523,
          collines: [
            { id: "10111101", name: "RUGANDO", population: 4675 },
            { id: "10111102", name: "RUGASA", population: 4835 },
            { id: "10111103", name: "MUYANGE", population: 3627 },
            { id: "10111104", name: "NYAMATA", population: 3192 },
            { id: "10111105", name: "KIGOMA", population: 3895 },
            { id: "10111106", name: "SARUDUHA", population: 3493 },
            { id: "10111107", name: "SHENGA", population: 2806 }
          ]
        },
        {
          id: "10112",
          name: "KIRI",
          total: 17194,
          collines: [
            { id: "10112101", name: "CIMO", population: 2570 },
            { id: "10112102", name: "MUNYINYA", population: 2725 },
            { id: "10112103", name: "KIRI", population: 3631 },
            { id: "10112104", name: "NTEMBE", population: 2273 },
            { id: "10112105", name: "MUGOMBWA", population: 2250 },
            { id: "10112106", name: "NGARAGU", population: 1568 },
            { id: "10112107", name: "MUBUGA", population: 2177 }
          ]
        },
        {
          id: "10113",
          name: "KIRUNDO",
          total: 25356,
          collines: [
            { id: "10113101", name: "QUARTIER BUSHAZA", population: 5789 },
            { id: "10113102", name: "QUARTIER KUMAHORO", population: 4973 },
            { id: "10113103", name: "QUARTIER RUPFUNDA", population: 5938 },
            { id: "10113104", name: "QUARTIER WINDORA", population: 2046 },
            { id: "10113105", name: "QUARTIER KAVOGERO", population: 1424 },
            { id: "10113106", name: "MURAMA", population: 5186 }
          ]
        },
        {
          id: "10114",
          name: "KIYONZA",
          total: 28296,
          collines: [
            { id: "10114101", name: "CINDONYI", population: 2387 },
            { id: "10114102", name: "NUNGA", population: 2378 },
            { id: "10114103", name: "KIYONZA", population: 3512 },
            { id: "10114104", name: "RUBUGA", population: 5279 },
            { id: "10114105", name: "NYAKARAMA", population: 3426 },
            { id: "10114106", name: "CINUMA", population: 3798 },
            { id: "10114107", name: "NINDA", population: 2804 },
            { id: "10114108", name: "GASAGARA", population: 2260 },
            { id: "10114109", name: "RUTAMO", population: 2452 }
          ]
        },
        {
          id: "10115",
          name: "MUGENDO",
          total: 39508,
          collines: [
            { id: "10115101", name: "KINYOVU", population: 5603 },
            { id: "10115102", name: "CARUBAMBO", population: 4851 },
            { id: "10115103", name: "BURINGANIRE", population: 4399 },
            { id: "10115104", name: "NTANGO", population: 5167 },
            { id: "10115105", name: "MUGENDO", population: 5156 },
            { id: "10115106", name: "RUTAGARA", population: 4393 },
            { id: "10115107", name: "MAKOMBE", population: 3242 },
            { id: "10115108", name: "SASA", population: 3779 },
            { id: "10115109", name: "MARIZA", population: 2918 }
          ]
        },
        {
          id: "10116",
          name: "MURUNGURIRA",
          total: 20141,
          collines: [
            { id: "10116101", name: "GITWENZI", population: 3973 },
            { id: "10116102", name: "MURUNGURIRA", population: 4262 },
            { id: "10116103", name: "KANYAGU", population: 3910 },
            { id: "10116104", name: "KAMENYA", population: 2628 },
            { id: "10116105", name: "SUSA", population: 2552 },
            { id: "10116106", name: "KIGINA", population: 2816 }
          ]
        },
        {
          id: "10117",
          name: "NTEGA",
          total: 32245,
          collines: [
            { id: "10117101", name: "NTEGA", population: 7230 },
            { id: "10117102", name: "NYEMERA", population: 4858 },
            { id: "10117103", name: "NYABISINDU", population: 4026 },
            { id: "10117104", name: "MONGE", population: 4341 },
            { id: "10117105", name: "MIHIGO", population: 3891 },
            { id: "10117106", name: "KIGAGA", population: 3521 },
            { id: "10117107", name: "GASAVE", population: 2009 },
            { id: "10117108", name: "RUGESE", population: 2369 }
          ]
        },
        {
          id: "10118",
          name: "NYAMABUYE",
          total: 19349,
          collines: [
            { id: "10118101", name: "GITWE", population: 4420 },
            { id: "10118102", name: "NYAMABUYE", population: 3727 },
            { id: "10118103", name: "KAMWAYI", population: 2841 },
            { id: "10118104", name: "RUKONDOKONDO", population: 2833 },
            { id: "10118105", name: "BWIZA", population: 2284 },
            { id: "10118106", name: "MUYUMPU", population: 1706 },
            { id: "10118107", name: "RYAGIHANA", population: 1538 }
          ]
        },
        {
          id: "10119",
          name: "RUNYANKEZI",
          total: 21486,
          collines: [
            { id: "10119101", name: "GISITWE", population: 8071 },
            { id: "10119102", name: "NGENDO", population: 3382 },
            { id: "10119103", name: "MWENDO", population: 2441 },
            { id: "10119104", name: "BUGORORA", population: 2217 },
            { id: "10119105", name: "RUKORE", population: 2964 },
            { id: "10119106", name: "RUNYANKEZI", population: 2411 }
          ]
        },
        {
          id: "10120",
          name: "RUSHUBIJE",
          total: 19122,
          collines: [
            { id: "10120101", name: "RUSHUBIJE", population: 4235 },
            { id: "10120102", name: "GATWE", population: 2975 },
            { id: "10120103", name: "NYAKIBINGO", population: 2976 },
            { id: "10120104", name: "MUYINZA", population: 1919 },
            { id: "10120105", name: "KANABUGIRI", population: 2684 },
            { id: "10120106", name: "RWIMBOGO", population: 1857 },
            { id: "10120107", name: "NKORWE", population: 2476 }
          ]
        },
        {
          id: "10121",
          name: "VUMBI",
          total: 37204,
          collines: [
            { id: "10121101", name: "GASURA", population: 8676 },
            { id: "10121102", name: "VUMBI", population: 7020 },
            { id: "10121103", name: "KABUYE", population: 4186 },
            { id: "10121104", name: "GIKOMERO", population: 3952 },
            { id: "10121105", name: "RWIMANZOVU", population: 3447 },
            { id: "10121106", name: "NYABIKENKE", population: 2738 },
            { id: "10121107", name: "MBASI", population: 2524 },
            { id: "10121108", name: "BUTSIMBA", population: 2813 },
            { id: "10121109", name: "SHORORO", population: 1848 }
          ]
        }
      ]
    }
  }
};

const PopulationDataPageButanyereraKirundo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredZones = data.province.commune.zones.map(zone => {
      const filteredCollines = zone.collines.filter(colline =>
        colline.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      
      return {
        ...zone,
        collines: filteredCollines,
        show: filteredCollines.length > 0 || 
              zone.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(zone => zone.show || !searchTerm);
    
    return {
      ...data,
      province: {
        ...data.province,
        commune: {
          ...data.province.commune,
          zones: filteredZones
        }
      }
    };
  };

  const filteredData = filterData(kirundoData, searchTerm);

  const keyStats = useMemo(() => {
    const commune = kirundoData.province.commune;
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, commune.zones[0].collines[0]);
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, commune.zones[0].collines[0]);

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

       
        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info KIRUNDO
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {kirundoData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de KIRUNDO`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de KIRUNDO
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population.toLocaleString()}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                      
                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.province.commune.zones.map((zone) => (
                          <React.Fragment key={zone.id}>
                            <ZoneRow 
                              hover 
                              onClick={() => toggleZone(zone.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {zone.name}
                                </Box>
                              </TableCell>
                            </ZoneRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {zone.collines.map((colline) => (
                                        <TableRow key={colline.id} hover>
                                          <TableCell sx={{ pl: 4 }}>{colline.name}</TableCell>
                                          <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                        </TableRow>
                                      ))}
                                      <TableRow>
                                        <TableCell sx={{ pl: 4, fontWeight: 'bold' }}>Total {zone.name}</TableCell>
                                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>{zone.total.toLocaleString()}</TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                        <TableRow sx={{ backgroundColor: '#e0e0e0', fontWeight: 'bold' }}>
                          <TableCell>TOTAL COMMUNE DE KIRUNDO</TableCell>
                          <TableCell align="right">{kirundoData.province.commune.total.toLocaleString()}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
               
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de KIRUNDO
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de KIRUNDO est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
              
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de KIRUNDO ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        
        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageButanyereraKirundo;